import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsConditions from "@/pages/TermsConditions";
import RefundPolicy from "@/pages/RefundPolicy";
import About from "@/pages/About";
import ContactUs from "@/pages/ContactUs";
import FAQ from "@/pages/FAQ";
import License from "@/pages/License";
import Disclaimer from "@/pages/Disclaimer";
import Download from "@/pages/Download";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/download" element={<Download />} />
                    <Route path="/about.html" element={<About />} />
                    <Route path="/contact-us.html" element={<ContactUs />} />
                    <Route path="/faq.html" element={<FAQ />} />
                    <Route path="/license.html" element={<License />} />
                    <Route path="/disclaimer.html" element={<Disclaimer />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/terms-and-conditions" element={<TermsConditions />} />
                    <Route path="/refund-policy" element={<RefundPolicy />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
